const OfflineOrderConstants = {
  APPLIED_STORE_FILTER: 'OFFLINE_ORDER/APPLIED_STORE_FILTER'
};
export default OfflineOrderConstants;
